module.exports = __webpack_public_path__ + "static/media/information-circle.cf31ecfe.svg";